import { orgWallClock } from '@/lib/utils/custom-date/custom-date';
import {
  COMPANY_ADDRESS,
  COMPANY_LINES,
  NOC_ASSET_BASE,
  NocLetterContent,
} from '../../utils/noc-pdf';

const logo = `${NOC_ASSET_BASE}/selisehrlogo.webp`;
const stamp = `${NOC_ASSET_BASE}/selise_stamp.png`;

/** On-screen A4 preview of the NOC letter (legacy noc-report); the downloaded PDF follows the same layout. */
export const NocLetterPreview = ({ letter }: { letter: NocLetterContent }) => {
  const [companyName, ...address] = COMPANY_ADDRESS;

  return (
    <div className="mx-auto w-full min-w-0 max-w-[794px] rounded-md border bg-white p-5 text-sm leading-relaxed text-black shadow-sm sm:p-12 sm:text-[15px]">
      <img src={logo} alt="SELISE" className="mb-6 h-12 w-auto" />

      <div className="mb-8 flex flex-col gap-4 sm:mb-12 sm:flex-row sm:justify-between sm:gap-6">
        <div className="flex flex-col gap-1">
          <span>{letter.documentNumber}</span>
          <span>{letter.letterDate}</span>
        </div>
        <div className="flex flex-col text-[11px] leading-snug">
          <span className="font-semibold">{companyName}</span>
          {address.map((line) => (
            <span key={line}>{line}</span>
          ))}
          <div className="mt-2 grid grid-cols-[auto_auto] justify-start gap-x-3">
            {COMPANY_LINES.map(([label, value]) => (
              <div key={label} className="contents">
                <span className="font-semibold text-gray-500">{label}</span>
                <span>{value}</span>
              </div>
            ))}
          </div>
          <div className="mt-2 flex flex-col">
            <a href="https://www.selisegroup.com" target="_blank" rel="noreferrer">
              www.selisegroup.com
            </a>
            <a href="mailto:info@selisegroup.com">info@selisegroup.com</a>
          </div>
        </div>
      </div>

      <h2 className="mb-9 text-center text-lg font-bold uppercase">To whom it may concern</h2>
      <div className="mb-16 whitespace-pre-line break-words text-left sm:text-justify">
        {letter.body}
      </div>

      <p className="mb-4">Sincerely,</p>
      <div className="mb-2 flex justify-end sm:mr-14">
        <img src={stamp} alt="SELISE stamp" className="h-28 w-28 object-contain" />
      </div>
      <div className="flex flex-col gap-1">
        <div className="mb-2 w-44 border-t border-black" />
        <span className="font-bold">{letter.pocName}</span>
        <span>{letter.pocDesignation}</span>
        <span>{companyName}</span>
        <span>
          <b>Email : </b>
          {letter.pocEmail}
        </span>
        <span>
          <b>Mobile BD : </b>
          {letter.pocMobile}
        </span>
      </div>

      <div className="mt-14 text-center text-[11px] text-gray-500">
        <span>
          © {companyName} {orgWallClock(new Date()).year}
        </span>
        <br />
        <span>
          This document is digitally signed with SELISE Signature and should be treated as an
          original.
        </span>
      </div>
    </div>
  );
};
